var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"value":_vm.value,"optionsPromise":_vm.taskTypePromise,"field":_vm.field,"placeholder":_vm.placeholder,"note":_vm.note},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }